import { RetrievePollPayload } from "@virtualprogaming/js-public-sdk";
import { isEmpty, partial } from "lodash";
import React, { FC, useState } from "react";
import { FormattedMessage } from "react-intl";

import useChatConversationPoll, {
  PollResponseData,
} from "~/queries/chat/poll/useChatConversationPoll";
import { Icon, LoadingIcon } from "~/ui/components/icons";
import { NoContentFound } from "~/ui/components/noContentFound";

import { Poll } from "./components/Poll";
import { PollActions } from "./components/PollActions";
import { PollForm } from "./components/PollForm";

export const PollPopup: FC<{
  chatId: number;
  members: RetrievePollPayload;
  onClose: () => void;
  isOwner: boolean;
  ownerId: number;
  shouldNotShowAction: boolean;
}> = ({
  onClose,
  chatId,
  members,
  isOwner = false,
  ownerId,
  shouldNotShowAction = false,
}) => {
  const { data: poll, isLoading } = useChatConversationPoll(chatId, members);

  const [isCreating, setIsCreating] = useState(false);
  const [pollToEdit, setPollToEdit] = useState<PollResponseData | null>(null);

  const handleEditClick = () => {
    if (!poll) return;
    setIsCreating(true);
    setPollToEdit(poll);
  };

  return isLoading ? (
    <div className="flex pd-t-md pd-b-sm justify-center items-center bg-light h-min-200px">
      <LoadingIcon size="lg" />
    </div>
  ) : (
    <div className="bg-light">
      <div className="flex justify-between items-center pd-b-sm border-bottom w-100">
        <h6 className="font-variant-small-caps pd-l-md mg-t-sm">
          <FormattedMessage defaultMessage="Poll" id="h1gtUi" />
        </h6>
        <Icon
          onClick={onClose}
          icon={["fal", "times"]}
          size="lg"
          className="pd-t-sm pd-r-sm pointer"
        />
      </div>
      {!isCreating && poll && isEmpty(poll?.poll) && (
        <NoContentFound>
          <span className="text-white">
            <FormattedMessage
              defaultMessage="No polls were found"
              id="S3aFMA"
            />
          </span>
        </NoContentFound>
      )}

      {!isCreating && poll && !isEmpty(poll?.poll) && (
        <Poll
          poll={poll}
          memberCount={members?.members?.length}
          members={members?.members}
          chatId={chatId}
        />
      )}

      {isCreating && (
        <PollForm
          chatId={chatId}
          ownerId={ownerId}
          onBack={() => {
            setIsCreating(false);
            setPollToEdit(null);
          }}
          pollToEdit={pollToEdit}
          shouldNotShowAction={shouldNotShowAction}
        />
      )}
      {poll && (
        <PollActions
          onEdit={handleEditClick}
          onNewClick={partial(setIsCreating, true)}
          isOwner={isOwner}
          poll={poll}
          chatId={chatId}
          isCreating={isCreating}
          shouldNotShowAction={shouldNotShowAction}
        />
      )}
    </div>
  );
};
